import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	toggleLabel: {
		id: 'issue-create.modal.create-form.request-type-fields-layout-preference.toggle-label',
		defaultMessage: 'Use request type fields',
		description:
			'Label positioned next to a toggle that allows the user to control whether or not their issue create form will use request type field or screen fields.',
	},
	createFormPopupTextWhenRequestTypeSelected: {
		id: 'issue-create.modal.create-form.request-type-fields-layout-preference.create-form-popup-text-when-request-type-selected',
		defaultMessage:
			'When this feature is on, you’ll see the fields connected to the request type you’ve selected. When it’s off, you’ll see issue type fields instead.',
		description:
			'Label positioned next to a toggle that allows the user to control whether or not their issue create form will use request type field or screen fields. ' +
			'This message variation is used when a request type has been selected on the issue being created.',
	},
	createFormPopupTextWhenNoRequestTypeSelected: {
		id: 'issue-create.modal.create-form.request-type-fields-layout-preference.create-form-popup-text-when-no-request-type-selected',
		defaultMessage: 'Select a request type to enable this feature.',
		description:
			'Label positioned next to a toggle that allows the user to control whether or not their issue create form will use request type field or screen fields. ' +
			'This message variation is used when a request type has been selected on the issue being created.',
	},
	createFormPopupTextWhenRequestTypeSelectedIssueTermRefresh: {
		id: 'issue-create.modal.create-form.request-type-fields-layout-preference.create-form-popup-text-when-request-type-selected-issue-term-refresh',
		defaultMessage:
			'When this feature is on, you’ll see the fields connected to the request type you’ve selected. When it’s off, you’ll see work type fields instead.',
		description:
			'Label positioned next to a toggle that allows the user to control whether or not their issue create form will use request type field or screen fields. ' +
			'This message variation is used when a request type has been selected on the issue being created.',
	},
});
